import Section from '../ui/Section/Section'
import Reveal from '../ui/Reveal/Reveal'
import { about, site } from '../../data/portfolio'
import styles from './About.module.css'

const About = ({ index }) => {
  const { bio, facts } = about
  const visibleFacts = facts.filter((fact) => fact.value)

  return (
    <Section id="about" index={index} title="About" eyebrow="About">
      <div className={styles.layout}>
        <Reveal className={styles.bio}>
          {bio.map((paragraph) => (
            <p key={paragraph.slice(0, 32)}>{paragraph}</p>
          ))}
        </Reveal>

        <Reveal className={styles.aside} delay={120}>
          <div className={styles.monogram} aria-hidden="true">
            <span>{site.initials}</span>
          </div>

          {visibleFacts.length > 0 && (
            <dl className={styles.facts}>
              {visibleFacts.map((fact) => (
                <div key={fact.label} className={styles.fact}>
                  <dt className={styles.factLabel}>{fact.label}</dt>
                  <dd className={styles.factValue}>{fact.value}</dd>
                </div>
              ))}
            </dl>
          )}
        </Reveal>
      </div>
    </Section>
  )
}

export default About
